var LocalStorageProvider = window.LocalStorageProvider = (function() {
    function clearOutdatedBettingCart() {
        var curTimestamp = Date.now();
        var cart: any = localStorage.getItem('bettingCart');
        var isBettingCartUpdated = false;

        if (cart) {

            cart = JSON.parse(cart);

            // если запись о последних изменениях в корзине делалалсь более 24 часов назад, она удаляется
            // для каждого пользователя проверяется отдельно
            for (var userData in cart) {
                if ((curTimestamp - cart[userData].timestamp) > (1000 * 60 * 60 * 24)) {
                    delete cart[userData];
                    isBettingCartUpdated = true;
                }
            }

            if (isBettingCartUpdated === true) {
                localStorage.setItem('bettingCart', JSON.stringify(cart));
            }
        }
    }

    return {
        clearOutdatedBettingCart
    }
})()